export default "__VITE_ASSET__BfttELqs__"